import { lazy } from 'react';

export default lazy(() =>
    // adblockers don't like "SocialIcons" so rot13 = FbpvnyVpbaf
    import(/* webpackChunkName: "FbpvnyVpbaf" */ './SocialLinkRowItem')
);
